export const PUBLISHER_FEATURES = {
  showManuscriptId: {
    publishers: ['springer-nature', 'test-hd'],
    journals: [] as Array<{ publisherSlug: string; journalSlug: string }>,
  },
};

export function isFeatureEnabled(
  feature: keyof typeof PUBLISHER_FEATURES,
  publisherSlug?: string | null,
  journalSlug?: string | null,
): boolean {
  const { publishers, journals } = PUBLISHER_FEATURES[feature];
  if (publisherSlug && publishers.includes(publisherSlug)) {
    return true;
  }
  if (publisherSlug && journalSlug) {
    return journals.some(
      (e) => e.publisherSlug === publisherSlug && e.journalSlug === journalSlug,
    );
  }
  return false;
}

export function isCochranePublisher(
  publisherSlug?: string | null,
  journalSlug?: string | null,
): boolean {
  return (
    publisherSlug === 'cochrane' ||
    publisherSlug === 'em-ods-cochrane' ||
    (publisherSlug === 'demo-publisher' && journalSlug === 'cochrane-ea')
  );
}

export function isPWCPublisher(
  publisherSlug?: string | null,
  journalSlug?: string | null,
): boolean {
  return (
    publisherSlug === 'pwc' ||
    (publisherSlug === 'demo-publisher' && journalSlug === 'pwc-test-ea')
  );
}
